import { connect } from 'react-redux';
import { SortDetails } from 'shared/page/SortDetails';
import type { ApiQueryParams, PaleState, PaleVertical } from '@/interfaces';
import { actions as filterActions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';
import { Breadcrumbs } from '../breadcrumbs/Breadcrumbs';
import { SortDropdown } from '../filters/SortDropdown';
import { ResultCount } from '../resultList/components/ResultCount';

type DesktopTopBarProps = {
    vertical: PaleVertical;
    numberOfOffers?: number;
    sortOptions?: string[];
    defaultSort: string;
    selectedSort?: string;
    changeSort: (newSort: string) => void;
    triggerFetch?: (queryParam?: ApiQueryParams) => void;
};

export const DesktopTopBar = ({
    vertical,
    numberOfOffers,
    sortOptions,
    defaultSort,
    selectedSort,
    changeSort,
    triggerFetch,
}: DesktopTopBarProps) => (
    <section className="hidden md:grid md:grid-cols-3 md:gap-32 my-16" data-testid="topBar">
        <div className="md:col-span-1">
            <Breadcrumbs vertical={vertical} />
        </div>
        <div className="md:col-span-2">
            <div className="flex justify-between items-center">
                <ResultCount numberOfOffers={numberOfOffers} vertical={vertical} />
                <div className="flex gap-16">
                    <SortDetails section={vertical === 'lms' ? 'restplasser' : 'pakkereiser'} />
                    <SortDropdown
                        defaultValue={defaultSort}
                        selectedValue={selectedSort}
                        sortOptions={sortOptions}
                        changeSort={changeSort}
                        triggerFetch={triggerFetch}
                    />
                </div>
            </div>
        </div>
    </section>
);

const mapStateToProps = (state: PaleState): Omit<DesktopTopBarProps, 'changeSort' | 'triggerFetch'> => ({
    vertical: 'pp',
    numberOfOffers: state.results.numberOfHotels,
    sortOptions: state.results.sortOptions,
    defaultSort: state.results.defaultSort,
    selectedSort: state.filters.sort,
});

export default connect(mapStateToProps, {
    changeSort: filterActions.changeSort,
    triggerFetch: fetchResults,
})(DesktopTopBar);
